function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
const StyledCell = styled.span.withConfig({
  displayName: "table-cell__StyledCell",
  componentId: "sc-1k2p79f-0"
})(["", " ", " ", " text-overflow:ellipsis;overflow:", ";white-space:nowrap;padding:0.5rem 0;"], ({
  align
}) => align === 'right' && 'justify-self: flex-end;', ({
  align
}) => align === 'left' && 'justify-self: flex-start;', ({
  align
}) => align === 'center' && 'justify-self: center;', props => props.overflow);
export const TableCell = ({
  align,
  children,
  overflow,
  ...rest
}) => /*#__PURE__*/React.createElement(StyledCell, _extends({
  align: align,
  overflow: overflow
}, rest), children);
TableCell.defaultProps = {
  overflow: 'hidden'
};
TableCell.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  overflow: PropTypes.oneOf(['visible', 'hidden'])
};